module.exports = __webpack_public_path__ + "static/img/yytx14.ba85f1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx14.png
// module id = 794
// module chunks = 0